<template>
  <div>
    <p style="font-size:16px;">正在跳转...</p>
  </div>
</template>

<script>
import {payOrder} from '@/api/api'

// const isMobileDevice = () => {
//   return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
// }
export default {
  name: "Redirect",
  mounted() {
    this.pay();
  },
  methods:{
    pay: function () {
      const { orderNo } = this.$router.history.current.params;
      // if (isMobileDevice()) {
      //   payOrder(orderNo).then(res => {
      //     window.location.href = res.codeUrl;
      //   });
      // }

      payOrder(orderNo).then(res => {
        window.location.href = res.codeUrl;
      });

    },
  }
}
</script>

<style scoped>

</style>